import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '../../base/base.component';

declare let gigya: any;

@Component({
  selector: 'app-lite-user-registration',
  templateUrl: './lite-user-registration.component.html',
  styleUrls: ['./lite-user-registration.component.css']
})
export class LiteUserRegistrationComponent extends BaseComponent implements OnInit{
  showContent:boolean = false;

  constructor(
    private zone: NgZone,
    private router: Router
    ) { 
      super();
    }

  ngOnInit(): void {
    setTimeout(()=>this.showContent=true, 500);
    
    gigya.accounts.showScreenSet({
      screenSet: 'ITU-RegistrationLogin',
      startScreen: 'itu-lite-user-registration',
      containerID: 'liteUserRegistration',
      onAfterSubmit: (event) => {
        if (event.screen == 'itu-confirmation-message') {          
          this.zone.run(() => {
            this.router.navigate(['/login']);
          });
        }
      }
    });
  }

}
